// src/components/kempower/SystemStatusCard.jsx
import React from 'react';

export default function SystemStatusCard({ operationalStatus, firmwareVersion, onFirmwareUpdate }) {
  // Example color if "Normal" => "text-success"


  return (
    <div className="card mb-3">
      <div className="card-body">
        <h6 className="fw-bold mb-3">System Status</h6>
        <div className="d-flex justify-content-between mb-2">
        </div>
        <div className="d-flex justify-content-between">
          <span>Firmware Version</span>
          <div>
            <span className="me-2">{firmwareVersion || 'N/A'}</span>
            {onFirmwareUpdate && (
              <button
                type="button"
                className="btn btn-link p-0 text-primary"
                style={{ fontSize: '0.85rem' }}
                onClick={onFirmwareUpdate}
              >
                Update
              </button>
            )}
          </div>
        </div>
      </div>
    </div>
  );
}
